export default __webpack_public_path__ + "static/media/user.47295419.svg";